import React from "react"

export const UsStorytelling = ({ type, storytelling_description }) => {
  return (
    <div className={`us-storytelling is-${type}`}>
      <div className="us-storytelling__text" dangerouslySetInnerHTML={{ __html: storytelling_description.html }} />
    </div>
  )
}
